<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="btn-right-side mb10">
        <el-tabs></el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['system:appVersion:add']">添加版本</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="安装包地址" prop="versionUrl" width="360"></el-table-column>
        <el-table-column label="系统类型" prop="versionType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.versionType==2?'ios':'安卓' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否强制更新" prop="escalationState" align="center">
          <template slot-scope="{row}">
            <span>{{ row.escalationState==1?'是':'否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文件大小" prop="versionSize" align="center">
          <template slot-scope="{row}">
            <span>{{ row.versionSize }}M</span>
          </template>
        </el-table-column>
        <el-table-column label="版本号" prop="versionName" align="center"></el-table-column>
        <el-table-column label="版本名称" prop="versionNumber" align="center"></el-table-column>
        <el-table-column label="版本code" prop="versionCode" align="center"></el-table-column>

        <el-table-column label="更新说明" prop="updateDescription" align="center" width="300"></el-table-column>
        <el-table-column label="更新时间" prop="operatedTime" align="center" width="160"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)" v-hasPermi="['system:appVersion:edit']">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)" v-hasPermi="['system:appVersion:delete']">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <notice-add ref="noticeAdd" @created="doQueryList({})" :popType="popType"/>
  </div>
</template>

<script>
  import noticeAdd from './add'
  import appVersionApi from '@/api/system/appVersion'
  import Pagination from '@/components/Pagination'
  export default {
    components: {
      Pagination,
      noticeAdd
    },
    data() {
      return {
        popType: 0, //0:新增 1:编辑
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          pushMethod:'',
          pushTimeStart:'',
          pushTimeEnd:'',
          times: null
        },
        selectItems: [],
        activeName: '1',
      }
    },
    created() {
      this.doQueryList({pageNo: 1})
    },
    methods: {
      /**
       * 选择框变化
       */
       selectionChange(val) {
        this.selectItems = val
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 重置
       */
      handleFilter() {
        this.query.pushMethod = ''
        this.query.times = null
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 获取列表数据
       */
      doQueryList({ pageNo, pageSize }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        if(this.query.times) {
          this.query.pushTimeStart = this.query.times[0]
          this.query.pushTimeEnd = this.query.times[1]
        }else {
          this.query.pushTimeStart = null
          this.query.pushTimeEnd = null
        }
        this.listLoading = true
        return appVersionApi.fetchList(this.query)
          .then(res => {
            this.list = res.data.list
            this.total = res.data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 删除单条记录
       */
      handleDeleteSingle(row) {
        return this.$common.confirm('是否确认删除')
          .then(() => appVersionApi.deleteById(row.id))
          .then(() => {
            this.$common.showMsg('success', '删除成功')
            return this.doQueryList({
              pageNo: 1
            })
          })
      },
      /**
       * 批量删除记录
       */
      handleDeleteBatch() {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择活动')
          return
        }
        return this.$common.confirm('是否确认删除')
          .then(() => appVersionApi.deleteBatch(this.selectItems.map(row => row.id)))
          .then(() => {
            this.$common.showMsg('success', '删除成功')
            return this.doQueryList({
              pageNo: 1
            })
          })
      },
      /**
       * 打开新建表单
       */
      handleCreate(row) {
        this.popType = 0
        this.$refs.noticeAdd.handleCreate(row)
      },
      /**
       * 打开查看表单
       */
      handleShow(row) {
        this.$emit('handleShow', row, 2)
      },
      /**
       * 打开编辑表单
       */
      handleUpdate(row, type) {
        // console.log('type: ',type);
        this.popType = type
        this.$refs.noticeAdd.handleUpdate({
          row,
          command: type
        })
      },
      handleDownload() {
        return this.$common.confirm('是否确认导出')
          .then(() => sysGoodsApi.exportExcel(this.query))
      },
    }
  }
</script>
